export default "__VITE_ASSET__BebY17_A__"